(function(module){
    "use strict";
    module.factory('CrossMessageCommunication',['$window', function($window){
        return{
            send: function(window, type, body){
                window.postMessage({type:type, body:body}, '*');
            },
            receive: function(obj){
                $window.addEventListener("message", function(e){
                    if(obj[e.data.type] && typeof obj[e.data.type] === 'function'){
                        obj[e.data.type](e.data.body);
                    }
                }, true);
            }
        }
    }]);
})(angular.module('CrossMessageCommunication.module', []));

